import { render, staticRenderFns } from "./SimilarActionsCell.vue?vue&type=template&id=1a4cecd2&scoped=true"
import script from "./SimilarActionsCell.vue?vue&type=script&lang=ts"
export * from "./SimilarActionsCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cecd2",
  null
  
)

export default component.exports